import React, { useState, useEffect } from 'react';
import { isMobile } from '@/biz/tool';
import { useTranslation } from 'react-i18next';
import axiosInstance from '@/apis/axiosInstance';
import { usePlatformStore } from '@/hooks/usePlatformStore';
import { Loading } from 'aha-components';

export default function VerificationContent({
  sendEmail,
  imgWidth
}: {
  sendEmail?: boolean;
  imgWidth?: string;
}) {
  const { user } = usePlatformStore();
  const { t } = useTranslation();
  const [countdown, setCountdown] = useState<number | null>(null);
  const [userEmail, setUserEmail] = useState<string>('');

  const goSendEmail = async (resend: boolean) => {
    const { data } = await axiosInstance.post(
      '/user/sendFirstApplyVerifyEmail',
      {
        resend
      }
    );
    if (data.code === 0) {
      setUserEmail(data?.data?.emails?.join(', ') || '');
    }
  };
  useEffect(() => {
    // 是打开弹窗 & 已登录 & 本次刷新没有发送过邮件
    if (sendEmail && user?.username) {
      goSendEmail(false);
    }
  }, [sendEmail, user?.username]);

  useEffect(() => {
    if (countdown === null || countdown === 0) {
      return;
    }

    const timer = setInterval(() => {
      setCountdown((prev) => {
        if (prev === null || prev <= 1) {
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [countdown]);

  const handleResendClick = () => {
    if (countdown === null || countdown === 0) {
      setCountdown(60);
      goSendEmail(true);
    }
  };

  return (
    <div className="w-full px-6 bg-[#fff] rounded-3xl flex flex-col items-center justify-center">
      <div className="w-full flex items-center justify-center -mb-[58px]">
        <img
          className={`${imgWidth ? imgWidth : 'w-[388px]'}`}
          src="/email-verification.png"
          alt="emailVerification"
        />
      </div>
      <div className="md:w-[500px] pl-1.5 pr-3 py-[8px] bg-[#FFF6ED] border border-[#FFD1A9] rounded-[8px] md:rounded-full inline-flex justify-center items-start md:items-center gap-2.5">
        <div className="px-2 py-[3px] bg-[#FB6011] rounded-[360px] flex justify-start items-center">
          <div className="justify-end text-[#fff] text-[12px] font-extrabold font-['Inter'] leading-3 italic">
            Tips
          </div>
        </div>
        <div
          className={`text-sm justify-start text-[#9B2911] -mt-[2px] leading-[16px] ${isMobile() ? '' : 'leading-4'}`}
        >
          <span className="">
            {t('modal.email_verification.add_email', { defaultValue: 'Add' })}{' '}
          </span>
          <span className="underline">support@creator.ahacreator.com</span>
          <span className="">
            {' '}
            {t('modal.email_verification.to_contacts', {
              defaultValue:
                'to your contacts to avoid missing AhaCreator notifications.'
            })}
          </span>
        </div>
      </div>
      <div className="text-center justify-start text-font&icon-primary text-xl font-semibold font-['DM_Sans'] leading-8 mt-3">
        {t('modal.email_verification.title', {
          defaultValue: 'Keep your collaboration updates out of spam'
        })}
      </div>
      {userEmail ? (
        <div className="self-stretch text-center justify-start text-[#79716B] text-base font-normal font-['DM_Sans'] leading-6 mt-3">
          {t('modal.email_verification.description', {
            defaultValue:
              'We’ve sent a confirmation email to your following email(s): {{userEmail}}. Please open the email and click “Confirm email” so future collaboration and payment updates go to your inbox, not spam.',
            userEmail: userEmail
          })}
        </div>
      ) : (
        <Loading width={50} height={50} color="#000" />
      )}
      <div
        className={`w-full px-4 py-2 rounded-md text-center mt-10 ${
          countdown !== null && countdown > 0
            ? 'bg-[#5A31F0]/50 cursor-not-allowed'
            : 'bg-[#5A31F0] cursor-pointer'
        }`}
        onClick={handleResendClick}
      >
        <div className="justify-start text-[#fff] text-sm font-medium font-['Inter'] leading-5">
          {t('modal.email_verification.resendEmail', {
            defaultValue: 'Resend email'
          })}
          {countdown !== null && countdown > 0 && (
            <span className="ml-2">({countdown}s)</span>
          )}
        </div>
      </div>
      <div className="self-stretch text-center justify-start mt-4">
        <span className="text-[#79716B] text-sm font-normal font-['DM_Sans'] leading-5">
          {t('modal.email_verification.cantFindIt', {
            defaultValue: 'Can’t find it?'
          })}{' '}
        </span>
        <span className="font-bold text-sm font-['DM_Sans'] leading-5">
          {t('modal.email_verification.checkSpam', {
            defaultValue: 'Check your Spam or Promotions folder'
          })}
        </span>
      </div>
    </div>
  );
}
